// ─────────────────────────────────────────────────────────────────────────────
// WHICH BUILD IS THIS?
//
// ⚠️ THE BACKEND COULD ANSWER THIS AND THE FRONTEND COULD NOT. /api/health
// reports the backend's commit, so a frontend fix "confirmed deployed" against
// it was confirmed against an unrelated pipeline — the mechanism behind at
// least three false all-clears. This module is the frontend's half of that
// answer.
//
// ⚠️ THE SOURCE MATTERS AS MUCH AS THE SHA. One commit becomes three different
// web builds: the Vercel browser bundle, a Capgo OTA bundle, and the bundle
// baked into a native binary. A phone can be running any of them. "The fix is
// deployed" is not a claim about the phone unless the source says so.
//
// Every producer stamps REACT_APP_COMMIT_SHA at build time:
//   vercel.json         → $VERCEL_GIT_COMMIT_SHA, source 'vercel'
//   ota-publish.yml     → github.sha,             source 'capgo-ota'
//   ios-build.yml       → github.sha,             source 'ios-native'
//   android-build.yml   → github.sha,             source 'android-native'
// ─────────────────────────────────────────────────────────────────────────────

// ⚠️ A VALUE THAT NEVER EXPANDED IS NOT A COMMIT. vercel.json's build.env does
// no shell interpolation, so "$VERCEL_GIT_COMMIT_SHA" arrived as that literal
// string and /version.json duly reported it as the commit. A wrong build
// identifier is worse than a missing one — it still reads as an answer.
const RAW_ENV = process.env.REACT_APP_COMMIT_SHA;
const RAW = RAW_ENV && !RAW_ENV.startsWith('$') ? RAW_ENV : null;

// ⚠️ 'unknown' RATHER THAN A FALLBACK THAT LOOKS PLAUSIBLE. A production build
// with no sha means a producer was added without stamping it; that must read as
// broken on screen, not as a valid-looking identifier nobody can match to a
// commit. Locally it says 'dev', which is true and unmistakable.
export const COMMIT_SHA = RAW || (process.env.NODE_ENV === 'production' ? 'unknown' : 'dev');
export const COMMIT_SHORT = COMMIT_SHA.slice(0, 7);
export const BUILD_SOURCE = process.env.REACT_APP_BUILD_SOURCE || 'local';
export const BUILT_AT = process.env.REACT_APP_BUILT_AT || null;

// One short line, readable by a person who is holding the phone that has the
// bug: "a1b2c3d · capgo-ota · 2026-08-19 14:02".
export const buildLine = () =>
  `${COMMIT_SHORT} · ${BUILD_SOURCE}${BUILT_AT ? ` · ${BUILT_AT.slice(0, 16).replace('T', ' ')}` : ''}`;
